// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ClientEndpointHealthWindow, IClientEndpointHealthWindow } from "./ClientEndpoints.ClientEndpointHealthWindow.gen";
import { EndpointAttachmentType } from "./Shared.Models.Api.V1.ClientEndpoints.EndpointAttachmentType.gen";
import { EndpointStatus } from "./Shared.Models.Api.V1.ClientEndpoints.EndpointStatus.gen";
import { ClientEndpointType } from "./Shared.Models.Api.V1.ClientEndpoints.ClientEndpointType.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsEmail, IsNotEmpty, IsOptional, ValidateIf } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IEmailClientEndpoint {
	emailAddress: string | undefined;

	description: string | undefined;

	attachment: EndpointAttachmentType;

	useCustomSmtpServer: boolean | undefined;

	fromEmail: string | undefined;

	username: string | undefined;

	server: string | undefined;

	port: number | undefined;

	password: string | undefined;

	useSsl: boolean | undefined;

	status: EndpointStatus;

	lastSuccessUtc: string | undefined;

	lastFailureUtc: string | undefined;

	failingSinceUtc: string | undefined;

	lastFailureMessage: string | undefined;

	consecutiveFailures: number;

	recentSendsConsidered: number;

	recentFailureCount: number;

	recentSlowSendCount: number;

	recentMaxMs: number | undefined;

	health: IClientEndpointHealthWindow | undefined;

	inUse: boolean;

	reportsDeliveryHistory: boolean;

	facilityName: string | undefined;

	deliversFromDevice: boolean;

	minimumFirmwareVersion: string | undefined;

	id: string | undefined;

	facilityId: string | undefined;

	organizationId: string | undefined;

	endpointName: string;

	enableHeartbeat: boolean;

	secondsBetweenHearbeat: number;

	includeTargetHistory: boolean;

	endpointType: ClientEndpointType;

	lastModifiedBy: string | undefined;

	lastModified: string | undefined;

	$type?: string | undefined;
}
export class EmailClientEndpoint {
	constructor(data?: IEmailClientEndpoint) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.lastSuccessUtc) { this.lastSuccessUtc = new Date(data.lastSuccessUtc); }
		if (data.lastFailureUtc) { this.lastFailureUtc = new Date(data.lastFailureUtc); }
		if (data.failingSinceUtc) { this.failingSinceUtc = new Date(data.failingSinceUtc); }
		if (data.health) { this.health = new ClientEndpointHealthWindow(data.health); }
		if (data.lastModified) { this.lastModified = new Date(data.lastModified); }
	}

	emailAddress: string | undefined;

	description: string | undefined;

	attachment: EndpointAttachmentType = 1;

	useCustomSmtpServer: boolean | undefined;

	@IsOptional()
	@ValidateIf(o => o.useCustomSmtpServer === true)
	@IsEmail({}, {
	  "message": "The $property field is not a valid e-mail address."
	})
	fromEmail: string | undefined;

	username: string | undefined;

	server: string | undefined;

	port: number | undefined;

	password: string | undefined;

	useSsl: boolean | undefined;

	status: EndpointStatus = 0;

	lastSuccessUtc: Date | undefined;

	lastFailureUtc: Date | undefined;

	failingSinceUtc: Date | undefined;

	lastFailureMessage: string | undefined;

	consecutiveFailures: number = 0;

	recentSendsConsidered: number = 0;

	recentFailureCount: number = 0;

	recentSlowSendCount: number = 0;

	recentMaxMs: number | undefined;

	health: ClientEndpointHealthWindow | undefined;

	inUse: boolean = false;

	reportsDeliveryHistory: boolean = false;

	facilityName: string | undefined;

	deliversFromDevice: boolean = false;

	minimumFirmwareVersion: string | undefined;

	id: string | undefined;

	facilityId: string | undefined;

	organizationId: string | undefined;

	@IsNotEmpty()
	endpointName: string = "";

	enableHeartbeat: boolean = false;

	secondsBetweenHearbeat: number = 0;

	includeTargetHistory: boolean = false;

	@IsNotEmpty()
	endpointType: ClientEndpointType = 1;

	lastModifiedBy: string | undefined;

	lastModified: Date | undefined;

	static $type: string = "CoreApi.Models.ClientEndpoints.EmailClientEndpoint, ";
	$type?: string | undefined = EmailClientEndpoint.$type;
}

